module.exports = __webpack_public_path__ + "static/media/Vortex-2WD-OV-3505.f6b696b0.png";